import { Box, Card, CardContent, Chip, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { Category } from "../../../data/models/product/ProductModel";

interface CategoriesListProps {
  categories: Category[];
  deleteCategory: (id: string) => Promise<void>;
}

export default function CategoriesList({
  categories,
  deleteCategory,
}: CategoriesListProps) {
  const [loadingId, setLoadingId] = useState<string | null>(null);

  const handleDelete = async (id: string) => {
    setLoadingId(id);
    await deleteCategory(id);
    setLoadingId(null);
  };

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 1,
        height: "100%",
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <CardContent>
        <Typography variant="subtitle1" fontWeight={600} mb={1}>
          Categorías
        </Typography>

        <Box
          sx={{
            maxHeight: 260,
            overflowY: "auto",
            pr: 0.5,
          }}
        >
          <Stack direction="row" flexWrap="wrap" gap={1}>
            {categories.map((cat) => (
              <Chip
                key={cat.id}
                label={cat.name}
                // onDelete={async () => handleDelete(cat.id!)}
                // deleteIcon={
                //   loadingId === cat.id ? (
                //     <CircularProgress size={16} />
                //   ) : (
                //     <IconButton
                //       size="small"
                //       sx={{
                //         "& svg": { fontSize: 16 },
                //       }}
                //     >
                //       <DeleteIcon />
                //     </IconButton>
                //   )
                // }
                sx={{
                  borderRadius: 999,
                  px: 1,
                  "& .MuiChip-label": { px: 1 },
                  opacity: loadingId === cat.id ? 0.6 : 1,
                }}
                variant="outlined"
                disabled={loadingId !== null}
              />
            ))}
            {categories.length === 0 && (
              <Typography variant="body2" color="text.secondary">
                Aún no tienes categorías creadas.
              </Typography>
            )}
          </Stack>
        </Box>
      </CardContent>
    </Card>
  );
}
